export default __webpack_public_path__ + "static/media/Deel.808df6d0.svg";